// import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import Conseil from './components/Conseil';
import Academie from './components/Academie';
import Performance from './components/Performance';
import Technologie from './components/Technologie';
import { Helmet } from 'react-helmet';
import { CssBaseline, Grid, ThemeProvider, createTheme } from '@mui/material';
import ServicesIndex from './components/ServicesIndex';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#9f1622',
      dark: '#76101a',
      light: '#c74650',
    },
    secondary: {
      main: '#1f2937',
    },
    background: {
      default: '#f7f5f2',
      paper: '#ffffff',
    },
    text: {
      primary: '#1c2028',
      secondary: '#626975',
    },
  },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontWeight: 750,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontWeight: 720,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    button: {
      fontWeight: 700,
      letterSpacing: '0.01em',
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 44,
          paddingInline: 22,
          borderRadius: 999,
          boxShadow: 'none',
        },
        containedPrimary: {
          boxShadow: '0 10px 24px rgba(159, 22, 34, 0.2)',
          '&:hover': {
            boxShadow: '0 12px 28px rgba(159, 22, 34, 0.28)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(31, 41, 55, 0.08)',
          boxShadow: '0 18px 45px rgba(31, 41, 55, 0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <div className="application">
      <Helmet>
        <meta charSet="utf-8" />
        <title>LCG Solution</title>
        <meta
          name="description"
          content="LCG Solution — expertise, accompagnement et solutions adaptées à vos ambitions."
        />
        <meta name="theme-color" content="#9f1622" />
      </Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Grid container direction="column" sx={{ flexGrow: 1, minHeight: '100vh' }}>
            <Grid item component="header" className="site-header">
              <Header />
            </Grid>
            <Grid item sx={{ flexGrow: 1 }}>
              <main className="site-main">
                <Routes>
                  <Route path="/" element={<Services />} />
                  <Route path="/a-propos" element={<About />} />
                  <Route path="/nous-joindre" element={<Contact />} />
                  <Route path="/services" element={<ServicesIndex />}>
                    <Route index element={<Services />} />
                    <Route path="conseil" element={<Conseil />} />
                    <Route path="academie" element={<Academie />} />
                    <Route path="performance" element={<Performance />} />
                    <Route path="technologie" element={<Technologie />} />
                  </Route>
                </Routes>
              </main>
            </Grid>
            <Grid item component="footer" className="site-footer">
              <Footer />
            </Grid>
          </Grid>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
